import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Notificacion } from '../../../pages/notificaciones/models'
import { DivisionDeNegocioOpcion } from '../../../pages/usuarios/models'
import { RootState } from '../../store'

type Sitio = {
  idSitio: string
  nombre: string
  razonSocial: string
  rfc: string
  descRazonSocial: string
}

type usuarioAutenticado = {
  username: string
  email: string
  nombre: string
  apellidoPaterno: string
  apellidoMaterno?: string
  perfil: string
  descPerfil: string
  notificacionesNoLeidas: number
  roles: string[]
  notificaciones: Notificacion[]
  divisionesNegocio: DivisionDeNegocioOpcion[]
  sitios: Sitio[]
}

type Autenticacion = {
  accessToken: string
  refreshToken: string
  usuario?: usuarioAutenticado | null
}

const initialState: Autenticacion = {
  accessToken: '',
  refreshToken: '',
  usuario: null,
}

/**
 * Guarda credenciales y datos funcionales del usuario autenticado.
 *
 * Los roles de `usuario` son usados por rutas, menu y componentes privados. Los
 * tokens se sincronizan tambien con localStorage para restaurar sesion al recargar.
 */
export const AutenticacionSlice = createSlice({
  name: 'autenticacion',
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<any>) => {
      const { accessToken, refreshToken } = action.payload
      return {
        ...state,
        accessToken,
        refreshToken,
      }
    },
    setUsuario: (state, action: PayloadAction<any>) => ({
      ...state,
      usuario: action.payload,
    }),
    cerrarSesion: () => ({
      ...initialState,
    }),
  },
})

export const { setTokens, setUsuario, cerrarSesion } = AutenticacionSlice.actions

export const selectUsuarioActual = (state: RootState) => state.autenticacion.usuario
export const selectUsuarioActualCorreo = (state: RootState) => state.autenticacion.usuario?.username
